import { render } from "./MuttonStarters.vue?vue&type=template&id=427c5596"
import script from "./MuttonStarters.vue?vue&type=script&lang=js"
export * from "./MuttonStarters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__